module.exports = __webpack_public_path__ + "static/media/290801.9b03b545.png";